/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_Map_Embed_HintInputs */

const vi_shop_contact_map_embed_hint = /** @type {(inputs: Shop_Contact_Map_Embed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã nhúng Google Maps: link bắt đầu bằng https://www.google.com/maps/embed?`)
};

/**

* @param {Shop_Contact_Map_Embed_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_map_embed_hint = /** @type {((inputs?: Shop_Contact_Map_Embed_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_Map_Embed_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_map_embed_hint(inputs)
});